import { sum } from 'lib/array/arrayUtils'
import getLoyaltyActionRewardProgress from 'loyalty/lib/getLoyaltyActionRewardProgress'

interface LoyaltyActionRewardsSummaryStats {
  completedCount: number
  totalCount: number
  pointsEarned: number
  pointsAvailable: number
}

export default function getLoyaltyActionRewardsSummary(
  rewards: Array<App.LoyaltyActionReward>,
): LoyaltyActionRewardsSummaryStats {
  let completedCount = 0
  let totalCount = 0
  let pointsAvailable = 0
  let pointsEarned = 0

  for (const reward of rewards) {
    const progress = getLoyaltyActionRewardProgress(reward)
    const estimateBonusPoints = reward.earnEstimate?.bonusPoints ?? 0
    const appliedBonusPoints = sum(reward.appliedRecords, (record) => record.bonusPoints ?? 0)
    pointsEarned += appliedBonusPoints

    switch (progress.kind) {
      case 'one_time':
      case 'capped':
        totalCount += progress.target
        completedCount += Math.min(progress.appliedCount, progress.target)
        break
      case 'unlimited':
        totalCount += Math.max(1, progress.appliedCount)
        completedCount += progress.appliedCount
        break
    }

    switch (progress.kind) {
      case 'one_time':
        pointsAvailable += appliedBonusPoints + estimateBonusPoints
        break
      case 'capped': {
        const remainingCount = Math.max(0, progress.target - progress.appliedCount)
        pointsAvailable += appliedBonusPoints + remainingCount * estimateBonusPoints
        break
      }
      case 'unlimited':
        pointsAvailable += progress.appliedCount > 0 ? appliedBonusPoints : estimateBonusPoints
        break
    }
  }

  return {
    completedCount,
    totalCount,
    pointsEarned,
    pointsAvailable,
  }
}
